<template>
	<div class="shouye-bottom">
		<Row>
			<Col span="12">
				<div>今日工作</div>
				<Table :columns="columns1" :data="data1"></Table>
			</Col>
			<Col span="12">col-12</Col>
		</Row>
	</div>
</template>
<style scoped lang="less">

</style>
<script>
	import Calendar from './Calendar.vue'

	import {
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getHomeBottom
	} from '@/api/shouye'
	import {
		getUserList,
		getRoleList,
		getDepartmentList
	} from '@/api/user'

	export default {
		name: "ShouyeWork",
		components: {
			Calendar
		},
		computed: {
			...mapGetters(['token']),
		},
		data() {
			return {
                columns1: [
                    {
                        title: '约见个数',
                        key: 'name'
                    },
                    {
                        title: '通话个数',
                        key: 'age'
                    },
                    {
                        title: '通话时长',
                        key: 'address'
                    },
					{
					    title: '约见个数',
					    key: 'name'
					},
					{
					    title: '通话个数',
					    key: 'age'
					},
					{
					    title: '通话时长',
					    key: 'address'
					},
					{
					    title: '约见个数',
					    key: 'name'
					},
					{
					    title: '通话个数',
					    key: 'age'
					},
					{
					    title: '通话时长',
					    key: 'address'
					}
                ],
                data1: [
                    {
                        name: 'John Brown',
                        age: 18,
                        address: 'New York No. 1 Lake Park',
                        date: '2016-10-03'
                    },
                    {
                        name: 'Jim Green',
                        age: 24,
                        address: 'London No. 1 Lake Park',
                        date: '2016-10-01'
                    },
                    {
                        name: 'Joe Black',
                        age: 30,
                        address: 'Sydney No. 1 Lake Park',
                        date: '2016-10-02'
                    },
                    {
                        name: 'Jon Snow',
                        age: 26,
                        address: 'Ottawa No. 2 Lake Park',
                        date: '2016-10-04'
                    }
                ]				
			}
		},
		created() {
			var Today = new Date()
			var stryesterday = Today.format("yyyy-MM-dd")
			this.teamTime = stryesterday
			this.loadData();
			this.timestampToTime(7, this.teamTime)
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),

			dateClick(e) {
				this.teamTime = e
				this.timestampToTime(7, e);
				this.getList()
			},
			detailClick() {
				this.$router.push('/client')
			},

			timestampToTime(type, time) {
				// type =0 为当天 type = 1 为前一天
				// hhmmss 自己传需要的时分秒
				let now = new Date(time);
				let date
				if (type === 0) {
					date = new Date(now + 8 * 3600 * 1000); // 增加8小时 当天
				} else {
					this.weekDayList = []
					for (let i = 0; i < type; i++) {
						let now = new Date(time);
						date = new Date(now - 3 * (i + 1) * 8 * 3600 * 1000); // type天前
						var time2 = date.getDate() + "日";
						this.weekDayList.unshift(time2)
					}
					for (let i = 0; i < type + 1; i++) {
						let now = new Date(time);
						date = new Date(now - 3 * (-i) * 8 * 3600 * 1000); // type天前
						var time2 = date.getDate() + "日";
						this.weekDayList.push(time2)
					}
				}
			},
			async loadData() {
				let data = {
					token: this.token
				}
				let that = this;
				var res = await getUserList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
				}
				var res = await getRoleList(that, data);
				if (res.code == 1) {
					that.roleList = res.data.list;
				}
				var res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.deparmentList = res.data.list;
				}
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {
					token: this.token
				}
				data.schedule = this.schedule;
				data.period = this.period;
				data.teamTime = this.teamTime;
				data.time = this.time;
				if (data.schedule == 1) {
					that.$nextTick(function() {
						data.currentYearMonth = this.$refs.calendar.currentYearMonth
						data.currentWeekday = this.$refs.calendar.currentWeekday
					})
					let res = await getHomeBottom(that, data);
					that.weekData = res.data.weekList || [];
					that.monthData = res.data.monthList || [];
				} else {
					data.roleId = this.roleId;
					data.userId = this.userId;
					data.departmentId = this.departmentId;
					let res = await getHomeBottom(that, data);
					that.dataList = res.data.list;
				}
			},
			scheduleClick(e) {
				this.periodShow = !this.periodShow;
				this.getList()
			},
			//周期单选框选择触发
			periodClick(e) {
				if (e == '1') {
					this.$refs.calendar.switchMonth()
				} else {
					this.$refs.calendar.switchWeek()
				}
				this.getList();
			}
		}
	}
</script>


